<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="goback">
        <div @click="goback">
          <i class="el-icon-arrow-left"></i>
          <span v-if="objectValue.state == 1">待处理详情</span>
          <span v-if="objectValue.state == 2">已处理详情</span>
          <span v-if="objectValue.state == 3">已评价详情</span>
        </div>
      </div>
      <div class="content">
        <div class="swiper">
          <swiper
            class="scrollItem"
            :options="swiperOptions"
            style="width: 100%"
          >
            <swiper-slide v-for="(item, index) in imgList" :key="index">
              <img :src="imgUrl + item" alt="" @click="previewImg(item)" />
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div>
        </div>
        <div class="filed filed_box">
          <div class="filed_label">描述内容</div>
          <div class="value_textarea">
            <van-field
              v-model="objectValue.content"
              rows="3"
              type="textarea"
              placeholder="请输入描述"
              maxlength="200"
              show-word-limit
              disabled
            />
          </div>
        </div>
        <div class="line"></div>
        <div class="filed_type">
          <div class="left">类型</div>
          <div class="right">{{ objectValue.typeName }}</div>
        </div>
        <div class="filed_type">
          <div class="left">所属园区</div>
          <div class="right">{{ objectValue.placeName }}</div>
        </div>
        <div class="filed_type">
          <div class="left">位置</div>
          <div class="right">{{ objectValue.place }}</div>
        </div>
        <div class="line"></div>
        <div class="filed_type">
          <div class="left">处理人</div>
          <div class="right">{{ objectValue.disposeName }}</div>
        </div>
        <div class="filed_type">
          <div class="left">状态</div>
          <div class="right">
            {{
              objectValue.state == 1
                ? "待处理"
                : objectValue.state == 2
                ? "已处理"
                : "已评价"
            }}
          </div>
        </div>
        <div class="filed" v-if="objectValue.state != 1">
          <div class="filed_label">备注</div>
          <div class="value_textarea">
            <van-field
              v-model="objectValue.remark"
              rows="3"
              type="textarea"
              placeholder="暂无"
              maxlength="200"
              show-word-limit
              disabled
            />
          </div>
        </div>
        <div
          class="dispose_img"
          v-if="objectValue.state != 1 && imgList2.length > 0"
        >
          <div class="img_item" v-for="(item, index) in imgList2" :key="index">
            <img :src="imgUrl + item" alt="" @click="previewImg(item)" />
          </div>
        </div>
        <div
          class="filed"
          style="margin-top: 10px"
          v-if="objectValue.state != 1"
        >
          <div class="filed_label">评分</div>
          <div class="value_rate">
            <van-rate
              v-model="valueRate"
              :size="25"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
              :readonly="objectValue.state == 3 ? true : false"
            />
            <div>{{ valueRate }}分</div>
          </div>
        </div>
        <div
          class="filed"
          style="margin-top: 15px"
          v-if="objectValue.state != 1"
        >
          <!-- <div class="filed_label">备注</div> -->
          <div class="value_textarea">
            <van-field
              v-model="evaluate"
              rows="3"
              type="textarea"
              placeholder="暂无"
              maxlength="50"
              show-word-limit
              :disabled="objectValue.state == 3 ? true : false"
            />
          </div>
        </div>
      </div>
      <div class="footer" v-if="objectValue.state == 2">
        <el-button class="btn1" @click="submit">提交</el-button>
        <el-button class="btn2" @click="no">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// import api from "@/apis/evaluation";
// import moment from "moment";
import apis from "@/apis/photoCasually";
import { ImagePreview } from "vant";
export default {
  components: {},
  data() {
    return {
      imgList: [],
      imgList2: [],
      imgUrl: "",
      upload: "",
      objectValue: {},
      swiperOptions: {
        loop: false,
        autoplay: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      optionType: [],
      optionPlace: [],
      valueRate: 0,
      evaluate: "",
      userinfo: {},
    };
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    this.imgUrl = apis.imgUrl;
    this.upload = apis.upload;
    this.getDetail();
  },
  methods: {
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 放大预览
    previewImg(id) {
      console.log(id);
      // ImagePreview([this.imgUrl + id]);
      ImagePreview({
        images: [this.imgUrl + id],
        closeable: true,
      });
    },
    // 查看详情
    getDetail() {
      const { id } = this.$route.query;
      apis.detail({ id: id }).then((res) => {
        if (res.code == 200) {
          this.objectValue = res.data;
          this.imgList = res.data.image ? res.data.image.split(",") : [];
          this.imgList2 = res.data.disposeImage
            ? res.data.disposeImage.split(",")
            : [];
          this.valueRate = res.data.evaluateScore
            ? Number(res.data.evaluateScore)
            : 0;
          this.evaluate = res.data.evaluate ? res.data.evaluate : "";
        }
      });
    },
    // 提交
    submit() {
      const { id } = this.$route.query;
      if (!this.evaluate) return this.$message.error("请填写评价");
      if (this.valueRate == 0) return this.$message.error("请填写评分");
      const params = {
        id: id,
        empNo: this.userinfo.username,
        evaluateScore: this.valueRate,
        evaluate: this.evaluate,
      };
      apis.appraise(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("评价成功");
          this.getDetail();
          this.$router.go(-1);
        }
      });
    },
    // 返回
    no() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 40px 0;
  background: url("~@/assets/photoCasually/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
    width: 0;
  }
  .goback {
    margin: 10px 40px 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;
      width: 100%;
    }

    i {
      font-weight: bold;
      font-size: 48px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
      margin: 0 auto;
      font-weight: bold;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .content {
    background: #fff;
    border-radius: 30px;
    box-shadow: 0px -4px 27px 0px rgba(0, 0, 0, 0.07);
    padding: 40px 30px;
    width: 90%;
    margin: 30px auto 0;
    .swiper {
      width: 100%;
      margin: 0 auto;
      background: #fff;
      position: relative;
      img {
        width: 100%;
        height: 260px;
        border-radius: 30px;
      }
      ::v-deep {
        .swiper-pagination {
          width: 100%;
          height: 80px;
          // bottom: -3.9vh;
          //   margin-top: 10px;
          left: 0;
          bottom: 0;
          margin-bottom: -70px;
        }

        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: rgba(31, 190, 138, 1);
          margin: 0 5px;
        }
        .swiper-pagination-bullet-active {
          background-color: rgba(31, 190, 138, 1);
        }
      }
    }
    .filed_box {
      margin-top: 50px;
    }
    .filed_label {
      color: #969b9e;
      font-size: 30px;
    }
    .value_textarea {
      margin-top: 20px;
      ::v-deep {
        .van-cell {
          padding: 0;
          border: 1px solid #e4e6e8;
          border-radius: 20px;
        }
        .van-field__control {
          padding: 15px 20px;
        }
        .van-field__word-limit {
          padding: 0 20px 20px 0;
        }
      }
    }
    .line {
      width: 100%;
      height: 2px;
      background: #e4e6e8;
      margin: 30px 0 30px 0;
    }
    .filed_type {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      .left {
        font-size: 28px;
        color: #969b9e;
      }
      .right {
        color: #282b32;
        font-size: 30px;
        font-weight: bold;
      }
    }
    .dispose_img {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin-top: 30px;
      .img_item {
        width: 180px;
        height: 140px;
        margin-right: 20px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }
      }
    }
    .value_rate {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 28px;
    }
  }
  .footer {
    width: 90%;
    margin: 0 auto;
    .btn2 {
      border: none;
      background: none;
      color: #969b9e;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 0 0 30px !important;
      border-radius: 15px;
    }
    .btn1 {
      border: 1px solid #4fa27d;
      background: #4fa27d;
      color: #fff;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 60px 0 30px;
      border-radius: 15px;
    }
  }
}
</style>
